import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { CreateEditPrepWorksheetEnum } from 'Common/FieldEnum';

import * as types from './types';

export const getKitchenPrepWorksheetItems = requestObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'CentralKitchen/GetKitchenFulfilmentPrepWorksheets',
        requestObj
      );
      dispatch(
        success(
          types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_DATA,
          response.data.Data
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Kitchen items list. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(
        loading(types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_LOADING, false)
      );
    }
  };
};

export const saveKitchenPrepWorksheet = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.KITCHEN_PREP_WORKSHEET_SUBMITTING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'CentralKitchen/WriteKitchenFulfillmentPrepWorksheet',
        payload
      );
      dispatch(success(types.KITCHEN_PREP_WORKSHEET_SUBMIT));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while saving kitchen prep worksheet. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.KITCHEN_PREP_WORKSHEET_SUBMIT_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.KITCHEN_PREP_WORKSHEET_SUBMITTING, false));
    }
  };
};

export const setNeededPreparedQtyDiff = itemList => {
  return {
    type: types.CREATE_EDIT_NEEDED_PREPARED_DIFF,
    payload: itemList,
  };
};

export const emptyKitchenItemList = () => {
  return {
    type: types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_DATA,
    payload: [],
  };
};

export const clearKitchenErrors = () => {
  return {
    type: types.CLEAR_KITCHEN_ERROR,
  };
};

export const getKitchenPrepDetails = TransactionId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_KITCHEN_PREP_DETAIL, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `CentralKitchen/GetKitchenPrepWorksheetForViewEdit/${TransactionId}`
      );
      dispatch(
        success(
          types.SELECTED_KITCHEN_PREP_DETAIL,
          response.data.Data[CreateEditPrepWorksheetEnum.KitchenDetails]
        )
      );
      dispatch(
        success(
          types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_DATA,
          response.data.Data[CreateEditPrepWorksheetEnum.KitchenItemListDetails]
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while getting kitchen prep worksheet. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCHING_KITCHEN_PREP_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCHING_KITCHEN_PREP_DETAIL, false));
    }
  };
};

export const emptyEditObject = () => {
  return {
    type: types.SELECTED_KITCHEN_PREP_DETAIL,
    payload: null,
  };
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/createEditKitchenPrepWorksheet/actions.js